/**
 * Renders the Balance-Out title-screen layout (file IK9erYbwssffqvs7qXjo68,
 * node 602:4268) pixel-precisely.
 *
 * Used by both StartScene (the actual title) and GameScene (which re-creates
 * the same layout at boot so the StartScene → GameScene scene-switch is
 * visually seamless, then animates everything off as part of the intro).
 *
 * Returns an object containing every animatable sprite so the caller can
 * tween them — title artwork, foreground props, weight blocks and shelves.
 * The Play button is NOT created here; each scene owns its own (interactive
 * in StartScene, a static decoration that the intro fades out in GameScene).
 */
export function drawTitleScreen(scene) {
  // Wall (back-most)
  scene.add.rectangle(0, 0, 1280, 720, 0xfce3d0).setOrigin(0).setDepth(-10);

  // Shelves sit on the wall behind the table. Each 289x701 image already
  // bakes its boxes/items in — no separate shelf-items overlay. They're
  // anchored at the screen's bottom-left and bottom-right corners.
  // right-shelf uses origin (1,1) at (1280, 720) so the same sprite can
  // later slide in from off-screen-right during the entrance.
  const leftShelf = scene.add.image(0, 720, 'left-shelf').setOrigin(0, 1).setDepth(-9);
  const rightShelf = scene.add
    .image(1280, 720, 'right-shelf')
    .setOrigin(1, 1)
    .setDepth(-9);

  // Floor / counter — drawn in front of the shelves so the lower portion
  // of each shelf reads as tucked behind the table.
  scene.add.image(0, 720, 'new-table').setOrigin(0, 1).setDepth(-7);

  // Foreground props
  const itemBlueLeft = scene.add
    .image(277.6, 423, 'item-blue-left')
    .setOrigin(0)
    .setDepth(1);
  const itemPink = scene.add.image(36, 463, 'item-pink').setOrigin(0).setDepth(2);
  const itemYellowLeft = scene.add
    .image(100, 493, 'item-yellow-left')
    .setOrigin(0)
    .setDepth(2);
  const itemYellowRight = scene.add
    .image(810, 444, 'item-yellow-right')
    .setOrigin(0)
    .setDepth(2);
  const itemGreen = scene.add.image(907, 441, 'item-green').setOrigin(0).setDepth(2);
  const itemBlueRight = scene.add
    .image(1110, 465, 'item-blue-right')
    .setOrigin(0)
    .setDepth(3);

  // Weight blocks on the floor
  const weight2kg = scene.add
    .image(337, 574, 'weight-block-2kg')
    .setOrigin(0)
    .setDepth(4);
  const weight4kg = scene.add
    .image(666, 574, 'weight-block-4kg')
    .setOrigin(0)
    .setDepth(4);
  const weight3kg = scene.add
    .image(822, 593, 'weight-block-3kg')
    .setOrigin(0)
    .setDepth(4);
  const weight1kg = scene.add
    .image(1135, 566, 'weight-block-1kg')
    .setOrigin(0)
    .setDepth(4);

  // Title artwork
  const gameName = scene.add.image(421, 178, 'game-name').setOrigin(0).setDepth(5);

  return {
    leftShelf,
    rightShelf,
    itemBlueLeft,
    itemPink,
    itemYellowLeft,
    itemYellowRight,
    itemGreen,
    itemBlueRight,
    weight1kg,
    weight2kg,
    weight3kg,
    weight4kg,
    gameName,
  };
}
